import clsx from 'clsx';
import { LuChevronRight } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

export const RoundNextButton = ({
  size = 'md',
  ...props
}: RoundButtonProps) => (
  <RoundButton size={size} {...props}>
    <LuChevronRight
      className={clsx(
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
);
